<template>
  <PDFListing />
</template>

<script lang="ts" setup>
</script>
